import React from "react"
import { concatStrings, defineBgColor } from "../utilities"
import { slugify } from "../../helper/string"
import {
  defaultSpacingTop,
  defaultSpacingBottom,
} from "../../helper/defaultSpacing"

/**
 * The known padding constants and the mapping to the css class name suffix.
 */
const paddings = {
  "extra-small": "xs",
  small: "s",
  medium: "m",
  large: "l",
  "extra-large": "xl",
  "extra-extra-large": "xxl",
}

const definePadding = (props) => {
  const topPadding =
    paddings[props.data.space_before_class] ||
    defaultSpacingTop(props.baseClass) ||
    paddings[props.defaultPaddingTop] ||
    paddings[props.defaultPadding]
  const bottomPadding =
    paddings[props.data.space_after_class] ||
    defaultSpacingBottom(props.baseClass) ||
    paddings[props.defaultPaddingBottom] ||
    paddings[props.defaultPadding]
  return concatStrings(
    topPadding ? `u-Padding-top-${topPadding}` : "",
    bottomPadding ? `u-Padding-bottom-${bottomPadding}` : ""
  )
}

/**
 * Creates the section wrapper with anchor
 * @param props.baseClass The base module class
 * @param props.className An additional optional class name added after the base class
 * @param props.defaultBgColor The default background color (if needed)
 * @param props.defaultPadding The default padding for the module (top and bottom)
 * @param props.defaultPaddingTop The default top padding for the module
 * @param props.defaultPaddingBottom The default bottom padding for the module
 * @param props.data The content object
 * @param props.data.anchor_name The anchor name which is used sluggified as section id
 * @param props.data.space_before_class The explicitly defined top padding for this content
 * @param props.data.space_after_class The explicitly defined bottom padding for this content
 * @param props.data.background_color The explicitly defined background color
 * @param props.data.add_class additional class names
 * @param props.children The content inside the section
 * @param props.testid The identifier which can be used for automated ui tests
 * @param props.add_style Extra CSS Styling
 */
const Section = (props, ref) => {
  const anchorName = props.data.anchor_name
  const anchorId = anchorName ? slugify(anchorName) : undefined
  const testid = props.testid ? props.testid : null

  return (
    <section
      ref={ref}
      id={anchorId}
      style={props.add_style || {}}
      className={concatStrings(
        props.baseClass,
        props.className,
        defineBgColor(props.data.background_color, props.defaultBgColor),
        definePadding(props),
        props.data.add_class
      )}
      data-testid={testid}
    >
      {props.children}
    </section>
  )
}

export default React.forwardRef(Section)
